import React, { useState, useEffect } from 'react';
import styled from 'App/styled';
import { FormattedMessage } from '@nykaa/intl-shared';

import ImageList, { ImageProps } from './ImagesList';
import { DYNAMIC_SHADES, DYNAMIC_SIZES } from 'constants/strings';

interface ProductDetailsProps {
  images: ImageProps[];
  title: string;
  packSize: string;
  optionsLength: number;
  isSize?: boolean;
}

const Wrapper = styled.div`
  background-color: #ffffff;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: flex-start;
  margin-right: 5px;
  margin-top: 5px;
  padding: 8px;
  width: 100%;
  position: relative;
  min-height: 138px;
`;

const ImageWrapper = styled.div`
  width: 115px;
  height: 115px;
  vertical-align: middle;
  margin-right: 7px;

  img {
    width: auto;
    height: 115px;
    vertical-align: middle;
    margin-right: 7px;
  }
`;

const DetailsWrapper = styled.div`
  overflow: hidden;
  ${({ theme }) => theme.typography.bodyMedium};
`;

const NameWrapper = styled.div`
  margin-bottom: 2px;
`;

const VariantInfo = styled.div`
  margin-bottom: 12px;
  color: ${({ theme }) => theme.colors.textSecondary};

  .size,
  .shade {
    display: inline-block;
    line-height: 1;
  }
  .shade {
    border-left: 1px solid #979797;
    margin-left: 5px;
    padding-left: 5px;
  }
`;

const ProductDetails = ({
  title,
  packSize,
  optionsLength,
  images,
  isSize,
}: ProductDetailsProps) => {
  const [activeThumb, setThumb] = useState(0);
  useEffect(() => {
    setThumb(0);
  }, [images]);

  if (images && images.length > 0) {
    const thumbIndex = activeThumb < images.length ? activeThumb : 0;
    const activeImage = images[thumbIndex].url || '';
    return (
      <Wrapper>
        <ImageWrapper>
          <img
            src={activeImage}
            alt={title}
            loading="lazy"
          />
        </ImageWrapper>
        <DetailsWrapper>
          <NameWrapper>
            <span aria-label="product-name">{title}</span>
          </NameWrapper>
          <VariantInfo>
            <span className="size">{packSize}</span>
            <span className={packSize ? 'shade' : 'size'}>
              <FormattedMessage
                id={isSize ? DYNAMIC_SIZES : DYNAMIC_SHADES}
                values={{ count: optionsLength }}
              />
            </span>
          </VariantInfo>
          <ImageList
            images={images}
            onImageSelect={setThumb}
            activeIndex={activeThumb}
          />
        </DetailsWrapper>
      </Wrapper>
    );
  }
  return null;
};

export default ProductDetails;
